import produce from 'immer';

import { ScorecardRequiredModalAction } from './actions';
import {
  HIDE_SCORECARD_REQUIRED_MODAL,
  SHOW_SCORECARD_REQUIRED_MODAL,
} from './constants';
import { ScorecardRequiredNotice, ScorecardRequirement } from './types';

export interface ScorecardRequiredModalState {
  requirement: ScorecardRequirement | null;
  notice: ScorecardRequiredNotice | null;
}

export const initialState: ScorecardRequiredModalState = {
  requirement: null,
  notice: null,
};

const scorecardRequiredModalReducer = (
  state: ScorecardRequiredModalState = initialState,
  action: ScorecardRequiredModalAction,
): ScorecardRequiredModalState =>
  produce(state, draft => {
    switch (action.type) {
      case SHOW_SCORECARD_REQUIRED_MODAL: {
        draft.requirement = action.requirement;
        draft.notice = action.notice;
        break;
      }
      case HIDE_SCORECARD_REQUIRED_MODAL: {
        draft.requirement = null;
        draft.notice = null;
        break;
      }
      // no default
    }
  });

export default scorecardRequiredModalReducer;
